export enum AuthenticationResult {
    MISSING_PRIVILEGES = 'MISSING_PRIVILEGES',
    INVALID_USER_OR_PASSWORD = 'INVALID_USER_OR_PASSWORD',
    CAPTCHA_ERROR = 'CAPTCHA_ERROR',
    SUCCESS = 'SUCCESS',
}
